import { Component, Input } from '@angular/core';
import { ApplicantCorrespondenceForm } from '../../forms/applicant-correspondence.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-applicant-correspondence-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxMaskDirective, ValidationErrorsComponent],
  templateUrl: './applicant-correspondence-form.component.html'
})
export class ApplicantCorrespondenceFormComponent {

  @Input()
  public form: ApplicantCorrespondenceForm | undefined;

  @Input()
  public entityTypeCode: string | undefined;
}
